/**
 * Computes a hash value for the given string using a simple hashing algorithm.
 *
 * @param {string<string>} str - string to be hashed
 * @returns {string} The hash value as a string
 */
export const stringHash = str => {
  if (typeof str !== 'string' || str.length === 0) {
    return '';
  }
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }
  return hash.toString();
};
